import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";
import * as Typos from "src/components/atoms/Typographs";
import Images from "src/theme/Images";
import * as Buttons from "src/components/atoms/Buttons";
import styled from "styled-components";
import { APP_LINK, Status } from "src/config";
import { SHARE_BUTTON } from "src/theme/Labels";
import LogoLoader from "src/components/Loader";
import friendService from "src/services/friend.service";
import { CheckboxWrapper } from "src/theme/Styled";
import routes from "src/constants/routes";
import { htmlLinkEscape } from "src/utils/functions";
import userService from "src/services/user.service";
import { USER_EX } from "src/constants/placeholders";
import { Link } from "react-router-dom";
import ACTIONS from "src/redux/actions";

import Modal from "react-responsive-modal";
import { Submit } from "src/components/atoms/Buttons";
import LOGINACTION from "src/redux/actions";
import { LOGIN_NAVIGATE_BUTTON } from "src/theme/Labels";

const ShareModal = (props) => {
  const user = useSelector((state) => state.users?.user);
  const dispatch = useDispatch();
  const [sourceFriends, setSourceFriends] = useState([]);
  const [friends, setFriends] = useState([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [note, setNote] = useState("");
  const [link, setLink] = useState("");
  const [copied, setCopied] = useState(false);
  const copyAction = useRef();
  const [shareStatus, setShareStatus] = useState(Status.NONE);
  const [selected, setSelection] = useState([]);
  const [error, setError] = useState("");
  const [isLoginModal, setisLoginModal] = useState(false);

  const showLoginModal = () => {
    setisLoginModal(true);
  };

  const openSign = () => {
    setisLoginModal(false);
    dispatch({
      type: LOGINACTION.SIDEBAR.OPEN_SIGN,
    });
  };

  const fetchFriends = () => {
    setLoading(true);
    friendService
      .loadFriends()
      .then((data) => {
        setLoading(false);
        data.sort((a, b) =>
          a.friend?.firstname.toLowerCase() + " " + a.friend?.lastname.toLowerCase() >
            b.friend?.firstname.toLowerCase() + " " + b.friend?.lastname.toLowerCase()
            ? 1
            : -1
        );

        setSourceFriends(data);
        setFriends(data);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const filterFriends = (e) => {
    setKeyword(e.target.value);
    let str = e.target.value.toLowerCase();
    const filtered = [];
    sourceFriends.forEach((e) => {
      const firstname = e.friend?.firstname || "";
      const lastname = e.friend?.lastname || "";
      let name = (firstname + " " + lastname).toLowerCase();
      if (name.indexOf(str) !== -1) {
        filtered.push(e);
      }
    });
    setFriends(filtered);
  };

  const toggleSelection = (e) => {
    const id = e._id;
    const pos = selected.indexOf(id);
    if (pos !== -1) {
      selected.splice(pos, 1);
    } else {
      selected.push(id);
    }
    setSelection([...selected]);
    setError("");
  };

  const changeNote = (e) => {
    setNote(e.target?.value);
  };

  const shareData = () => {
    if (!selected.length) {
      setError("Select a friend to share with.");
      return;
    }
    var emailContent;
    var subject;
    const fullname = user.firstname + " " + user.lastname;
    const username = fullname || user.username || "Unnamed User";
    
    if (props.type === "wish-item") {
      emailContent = `<p>${username} wanted to share ${props.data.length === 1 ? "this" : "these"
        } with you from The Gift Guide!</p>`;
      emailContent += note ? `"${note}"<br/>` : "";
      subject = `${username} wanted to share ${props.data.length === 1 ? "this" : "these"
        } with you!`;
      let wishItemsText = ``;
      props.data.map((item) => {
        let link = APP_LINK + routes.OTHER_WISH_LIST + item._id;
        let wishItemText = `- <a href="${link}" class="primary underline">${item.name}</a>`;
        wishItemsText += wishItemText + "<br />";
        return true;
      });
      emailContent += "<br/>" + wishItemsText;
    } else if (props.type === "profile") {
      emailContent = `<p>${username} wanted to share this user with you from The Gift Guide!</p>`;
      emailContent += note ? `"${note}"<br/>` : "";
      subject = `${username} wanted to share this user with you!`;
      let profileLink =
        APP_LINK + routes.ALL_USERS + "/" + props.data?.username;
      emailContent += `<br/><a class="underline primary" href="${profileLink}">${props.data?.fullname}</a>`;
    } else {
      emailContent = `<p>${username} wanted to share this with you from The Gift Guide!</p>`;
      emailContent += note ? `"${note}"<br/>` : "";
      subject = `${username} wanted to share this with you!`;
      let link = `<a class="primary underline" href="${APP_LINK}${routes.GIFTGUIDES}/${props.data._id}">${props.data.title}</a>`;
      emailContent += "<br/>" + link;
    }

    // api call
    setShareStatus(Status.REQUEST);
    userService
      .shareData({
        users: selected,
        content: emailContent,
        subject: subject,
      })
      .then(() => {
        setShareStatus(Status.SUCCESS);
        setTimeout(() => {
          setShareStatus(Status.NONE);
        });
        props.onClose && props.onClose();
      })
      .catch(() => {
        setShareStatus(Status.FAILURE);
      });
  };

  const openEmail = () => {
    const fullname = user.firstname + " " + user.lastname;
    const username = fullname || user.username || "Unnamed User";
    var emailContent = "";
    var subject = "";
    if (props.type === "wish-item") {
      emailContent = `I wanted to share this with you from The Gift Guide.\n`;
      emailContent += note ? note : "";
      subject = `Wanted to share this with you!`;
      let wishItemsText = ``;
      props.data.map((item, index) => {
        let link = APP_LINK + routes.OTHER_WISH_LIST + item._id;
        let wishItemText = `- ${htmlLinkEscape(item.name)}
            ${link}`;
        wishItemsText += wishItemText + "\n";
        return true;
      });
      emailContent += "\n" + wishItemsText;
      emailContent += `\n\nP.S. As part of The Gift Guide community, you can follow loved ones and receive reminders for upcoming events, including their wish lists and favorites to help you find the perfect gift.\n\nJoin me on https://www.thegiftguide.com, the single source for all your gifting needs.`;

      let linkHref = `mailto:?subject=${subject}&body=${encodeURI(
        emailContent
      )}`;
      let aDom = document.createElement("a");
      aDom.href = linkHref;
      aDom.target = "_blank";
      aDom.click();
      document.querySelector("body").appendChild(aDom);
    } else if (props.type === "profile") {
      emailContent = "I wanted to share this with you from The Gift Guide.\n";
      emailContent += note ? note : "";
      subject = `Wanted to share this with you!`;
      let profileText = `${APP_LINK}${routes.ALL_USERS}/${user.username}`;
      emailContent += "\n" + profileText;
      emailContent += `\n\nP.S. As part of The Gift Guide community, you can follow loved ones and receive reminders for upcoming events, including their wish lists and favorites to help you find the perfect gift.\n\nJoin me on https://www.thegiftguide.com, the single source for all your gifting needs.`;
      let linkHref = `mailto:?subject=${subject}&body=${encodeURI(
        emailContent
      )}`;
      let aDom = document.createElement("a");
      aDom.href = linkHref;
      aDom.target = "_blank";
      aDom.click();
      document.querySelector("body").appendChild(aDom);
    } else {
      emailContent = "I wanted to share this with you from The Gift Guide.\n";
      emailContent += note ? note : "";
      subject = `Wanted to share this with you!`;
      let link = `${htmlLinkEscape(props.data.title)}
        ${APP_LINK}${routes.GIFTGUIDES}/${props.data._id}`;
      emailContent += "\n" + link;
      emailContent += `\n\nP.S. As part of The Gift Guide community, you can follow loved ones and receive reminders for upcoming events, including their wish lists and favorites to help you find the perfect gift.\n\nJoin me on https://www.thegiftguide.com, the single source for all your gifting needs.`;
      let linkHref = `mailto:?subject=${subject}&body=${encodeURI(
        emailContent
      )}`;
      let aDom = document.createElement("a");
      aDom.href = linkHref;
      aDom.target = "_blank";
      aDom.click();
      document.querySelector("body").appendChild(aDom);
    }
  };

  const copyLink = () => {
    let linkText = ``;
    if (props.type === "wish-item") {
      props.data.map((item) => {
        let link = APP_LINK + routes.OTHER_WISH_LIST + item._id;
        linkText += link + "\n";
        return true;
      });
    } else if (props.type === "profile") {
      linkText += APP_LINK + "/users/" + props.data?.username;
    } else {
      linkText = `${APP_LINK}${routes.GIFTGUIDES}/${props.data?._id}`;
    }

    setLink(linkText);
    setTimeout(() => {
      copyAction.current && copyAction.current.click();
    }, 500);
  };

  const openLogin = () => {
    dispatch({
      type: ACTIONS.SIDEBAR.OPEN_SIGN,
    });
  };

  const onCopied = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  useEffect(() => {
    fetchFriends();
  }, []);

  const renderFriendRow = (item) => {
    return (
      <>
        <div className="image-wrapper">
          {item.avatar ? (
            <img src={item.avatar} alt="wish-item" />
          ) : (
            <div className="name-avatar">
              <div className="name">
                {item.firstname[0]}
                {item.lastname[0]}
              </div>
            </div>
          )}
        </div>
        <Typos.FLabel className="text-center mt-0">
          {item.firstname.toUpperCase()} {item.lastname.toUpperCase()}
        </Typos.FLabel>
        <CheckboxWrapper className="ml-auto">
          <input
            type="checkbox"
            style={{ cursor: "pointer" }}
            onChange={() => toggleSelection(item)}
            checked={selected.includes(item._id)}
            id={`sd-friend-${item._id}`}
          />
          <Typos.FLabel></Typos.FLabel>
        </CheckboxWrapper>
      </>
    );
  };

  const renderPlaceholder = (item) => {
    return (
      <>
        <div className="image-wrapper placeholder">
          <img src={item.picture} alt="wish-item" />
        </div>
        <Typos.FLabel className="text-center mt-0 fake-text">
          {item.fullname}
        </Typos.FLabel>
        <CheckboxWrapper className="ml-auto placeholder">
          <input type="checkbox" id={`sd-friend-${item.fullname}`} />
          <Typos.FLabel></Typos.FLabel>
        </CheckboxWrapper>
      </>
    );
  };

  return (
    <CS.Container>
      <Typos.PageTitle className="text-center">Share</Typos.PageTitle>
      <div className="">
        <CS.ActionItem onClick={openEmail} style={{ cursor: "pointer" }}>
          <img className="" src={Images.EmailIcon} />
          <Typos.FLabel size={14} spacing="0" style={{ cursor: "pointer" }}>
            Share via email
          </Typos.FLabel>
        </CS.ActionItem>
        <CS.ActionItem onClick={copyLink} style={{ cursor: "pointer" }}>
          <img className="" src={Images.LinkIcon} />
          <Typos.FLabel size={14} spacing="0" style={{ cursor: "pointer" }}>
            Copy link
          </Typos.FLabel>
          {copied ? (
            <Typos.FLabel className="ml-auto" spacing="0">
              Copied
            </Typos.FLabel>
          ) : null}
        </CS.ActionItem>
      </div>
      <div className={props.disable ? "mt-3 login_disable" : "mt-3"}>
        <Typos.FLabel style={{ color: !user && "#c7c7c7" }}>
          Share With Friends
        </Typos.FLabel>
        <div className="d-flex v-center">
          <input
            type="text"
            onChange={filterFriends}
            style={{ border: !user && "1px solid #c7c7c7" }}
            disabled={props.disable}
          />
          <CS.SearchIcon src={Images.searchIcon} className={props.disable ? "ml-2 login_disable" : "ml-2"} />
        </div>
      </div>
      <CS.List>
        {loading ? (
          <LogoLoader />
        ) : friends?.length ? (
          <div className="inner-list">
            {(friends || []).map((item, index) => (
              <CS.Item key={item._id + "-" + index}>
                {renderFriendRow(item.friend)}
              </CS.Item>
            ))}
          </div>
        ) : (
          <CS.EmptyBox>
            <>
              {USER_EX.map((item, index) => (
                <CS.Item key={index} className="placeholder-item">
                  {renderPlaceholder(item)}
                </CS.Item>
              ))}
            </>
            <Typos.Desc className="text-center empty-desc">
              {props.disable ? (
                <>
                  <Typos.ExtraInfoText>
                    {/* You hasn't followed any friends yet{" "} */}
                    <a
                      className="c-pointer"
                      style={{ textDecoration: "underline" }}
                      onClick={openLogin}
                    >
                      Log in
                    </a>{" "}
                    to select your friends.
                  </Typos.ExtraInfoText>
                </>
              ) : (
                <>
                  {keyword ? (
                    "There are no friends that contains keyword"
                  ) : (
                    <Typos.PageGuide
                      style={{
                        marginRight: "5px",
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "black",
                        letterSpacing: "0rem",
                        lineHeight: "1.6",
                        fontSize: "16px",
                        fontFamily: "'Prata', serif",
                      }}>
                      <Link
                        to={routes.ALL_USERS}
                        className="td-underline "
                      >
                        Follow friends
                      </Link>
                      &nbsp;to select a user to share with
                    </Typos.PageGuide>
                  )}
                </>
              )}
            </Typos.Desc>
          </CS.EmptyBox>
        )}
      </CS.List>
      <div className={props.disable ? "mt-2 mb-2 login_disable" : "mt-2 mb-2"}>
        <Typos.FLabel style={{ color: !user && "#c7c7c7" }}>
          Add Personalized Note
        </Typos.FLabel>
        <textarea
          className="d-block w-100"
          style={{ minHeight: "80px" }}
          onChange={changeNote}
          disabled={props.disable}
        ></textarea>
      </div>
      {user ? (
        <Buttons.Submit
          status={shareStatus}
          title={SHARE_BUTTON}
          onClick={shareData}
          disabled={props.disable}
          theme={props.disable ? "disabled" : ""}
        />
      ) : (
        <Buttons.Submit title={SHARE_BUTTON} onClick={showLoginModal} />
      )}

      {error ? <Typos.Error>{error}</Typos.Error> : null}
      <CopyToClipboard text={link} onCopy={onCopied}>
        <button ref={copyAction} className="d-none"></button>
      </CopyToClipboard>

      <Modal
        open={isLoginModal}
        blockScroll={false}
        onClose={() => setisLoginModal(false)}
        classNames={{
          root: "loginModalroot",
          modal: "loginModal",
        }}
      >
        <Typos.PageTitle className="login_title">
          Oops, you need to login for that
        </Typos.PageTitle>
        <div className="login_description">
          In order to use that feature, you need to log in or create an account.
        </div>
        <div className="login_btn">
          <Submit
            type="button"
            title={LOGIN_NAVIGATE_BUTTON}
            onClick={openSign}
          />
        </div>
      </Modal>
    </CS.Container>
  );
};

const CS = {
  Container: styled.div`
    max-width: 320px;
    width: calc(100vw - 48px);
  `,
  ActionItem: styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 4px 0px;
    img {
      width: 24px;
      height: 24px;
      margin-right: 12px;
    }
  `,
  SearchIcon: styled.img`
    width: 30px;
    height: 30px;
  `,
  List: styled.div`
    min-height: 150px;
    padding-top: 8px;
    padding-bottom: 8px;
    max-height: calc(100vh - 480px);
    overflow-y: auto;

    .inner-list {
    }
  `,
  EmptyBox: styled.div`
    position: relative;

    .empty-desc {
      position: absolute;
      top: 25px;
      left: 0px;
      right: 0px;
    }
  `,
  Item: styled.div`
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 8px;
    .image-wrapper {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      overflow: hidden;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .name-avatar {
    }
  `,
};

export default ShareModal;
